import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import theme from './theme';
import { ThemeProvider } from '@material-ui/core';
import CustomSignIn from './user/CustomSignIn';
import { Authenticator } from 'aws-amplify-react';
import { SignIn, Greetings } from 'aws-amplify-react';
import config from './aws-exports';
//import * as serviceWorker from './serviceWorker';

const aws_theme = {
  toast: {
    textAlign: 'center',
    marginTop: 20,
    color: 'red',
    // position: 'absolute',
    // top: 0,
    // width: '100%',
  },
};

const errorHandler = () => {
  return 'Sign In Failed, Username or Password does not match.';
};

class AppWithAuth extends React.Component {
  render() {
    return (
      <div>
        <ThemeProvider theme={theme}>
          <Authenticator
            theme={aws_theme}
            errorMessage={errorHandler}
            hide={[SignIn, Greetings]}
            amplifyConfig={config}
          >
            <CustomSignIn />
            <App />
          </Authenticator>
        </ThemeProvider>
      </div>
    );
  }
}

ReactDOM.render(<AppWithAuth />, document.getElementById('root'));
